import { render, staticRenderFns } from "./ItemRontott6m.vue?vue&type=template&id=3738c52d&scoped=true&"
import script from "./ItemRontott6m.vue?vue&type=script&lang=js&"
export * from "./ItemRontott6m.vue?vue&type=script&lang=js&"
import style0 from "./ItemRontott6m.vue?vue&type=style&index=0&id=3738c52d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3738c52d",
  null
  
)

export default component.exports